import { useMemo } from 'react';

import { DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES } from '../config';
import { makeFullHeadMprSliceGroups } from '../lib';

export const useFullHeadMprSliceGroups = ({
  frames,
  pendingSeries,
  series,
  slabThicknessMm,
  sliceOptions = DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  sliceStepMm,
  toothID,
}: Parameters<typeof makeFullHeadMprSliceGroups>[0]) =>
  useMemo(
    () =>
      makeFullHeadMprSliceGroups({
        frames,
        pendingSeries,
        series,
        slabThicknessMm,
        sliceOptions: {
          axial: {
            sliceStepMm: sliceOptions.axial.sliceStepMm,
            thicknessMm: sliceOptions.axial.thicknessMm,
          },
          sagittal: {
            sliceStepMm: sliceOptions.sagittal.sliceStepMm,
            thicknessMm: sliceOptions.sagittal.thicknessMm,
          },
          frontal: {
            sliceStepMm: sliceOptions.frontal.sliceStepMm,
            thicknessMm: sliceOptions.frontal.thicknessMm,
          },
        },
        sliceStepMm,
        toothID,
      }),
    [
      frames,
      pendingSeries,
      series,
      slabThicknessMm,
      sliceOptions.axial.sliceStepMm,
      sliceOptions.axial.thicknessMm,
      sliceOptions.sagittal.sliceStepMm,
      sliceOptions.sagittal.thicknessMm,
      sliceOptions.frontal.sliceStepMm,
      sliceOptions.frontal.thicknessMm,
      sliceStepMm,
      toothID,
    ],
  );
